import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E06 — MORTIER. Le décor qui compte.
 *
 *  Il descend à sa station et ne bouge plus jamais. C'est tout, et c'est
 *  exactement le point : au bout de deux secondes le joueur cesse de le suivre
 *  des yeux et se met à le contourner comme un pilier. L'ennemi a changé de
 *  catégorie mentale sans changer de nature — il est devenu du TERRAIN.
 *
 *  ── Ce qu'il enseigne ──
 *  Que la position d'une menace peut être une donnée stable du niveau, et donc
 *  qu'on peut PLANIFIER autour d'elle. Toutes les autres leçons du bestiaire
 *  portent sur la réaction ; celle-ci porte sur l'itinéraire. Un joueur qui a
 *  compris le Mortier ne se demande plus « où est le danger » mais « par où je
 *  passe », et c'est une bascule qu'aucun ennemi mobile ne peut provoquer.
 *
 *  ── Pourquoi l'anneau, et pas un éventail ──
 *  Un émetteur immobile qui tirerait vers le bas créerait une colonne interdite
 *  permanente, c'est-à-dire un mur, c'est-à-dire une zone morte du terrain.
 *  L'anneau fait l'inverse : il émet dans toutes les directions, donc il rend
 *  chaque direction dangereuse PAR INTERMITTENCE. On traverse un anneau, on ne
 *  traverse pas une colonne.
 *
 *  Les +7° par volée sont ce qui empêche la figure de se refermer : deux
 *  anneaux successifs décalés laissent des interstices qui se décalent aussi,
 *  et l'ensemble se lit comme une fleur qui tourne. Sans ce décalage, les
 *  anneaux se superposeraient exactement et le Mortier produirait douze
 *  couloirs figés — un mur radial, joli et injouable.
 *
 *  ── Non collisionnable ──
 *  Rien dans le moteur ne fait mal au contact d'un corps : le Mortier est donc
 *  un obstacle VISUEL et balistique, jamais physique. C'est voulu — un pilier
 *  solide au milieu d'un shmup produit des morts par frottement qu'on ne
 *  comprend pas, et il faudrait alors le dessiner avec une précision que le
 *  reste du jeu n'a pas. */
export default defineEnemy({
  id: 'mortier',
  rank: Rank.Standard,
  hp: 320,
  visualRadius: 34,
  score: 260,
  telegraph: 1.1,
  drops: 3,
  /* Station à Y = +340 : au-dessus de la zone de manœuvre du joueur (plafonné à
     +510), assez bas pour que ses anneaux atteignent le bas du terrain avant de
     s'éteindre. La descente à 200 u/s prend ~1,6 s depuis l'apparition, ce qui
     lui laisse le temps d'être catégorisé pendant qu'il est encore inoffensif. */
  motion: { kind: Motion.Anchor, speed: 200, holdY: 340 },
  emitter: {
    pattern: Pattern.Ring,
    every: 2.2,
    count: 12,
    speed: 380,
    stepDeg: 7,
    /* Décalé de la période : le premier anneau ne part pas à la seconde où le
       télégraphe s'éteint. Un ennemi qui devient dangereux et tire dans le même
       souffle annule le bénéfice de son propre télégraphe. */
    firstDelay: 1.8,
    family: Fam.EnemyPurple,
  },
});
